// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../store-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-7b8ecf2c]{border-radius:.5rem;padding:.5rem}.basket-enter-active[data-v-7b8ecf2c],.basket-leave-active[data-v-7b8ecf2c]{transition:all .3s}.basket-enter[data-v-7b8ecf2c]{opacity:0;transform:translatey(.5rem)}.basket-leave-to[data-v-7b8ecf2c]{opacity:0;transform:translateY(-.5rem)}", ""]);
// Exports
module.exports = exports;
